import { render, staticRenderFns } from "./VoucherCarousel.vue?vue&type=template&id=a5bc99ba&scoped=true"
import script from "./VoucherCarousel.vue?vue&type=script&lang=js"
export * from "./VoucherCarousel.vue?vue&type=script&lang=js"
import style0 from "./VoucherCarousel.vue?vue&type=style&index=0&id=a5bc99ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bc99ba",
  null
  
)

export default component.exports